module.exports = __webpack_public_path__ + "img/icon-dropdown.a3b48115.svg";